<app-dialog
  [title]="title"
  [actions]="actions"
  [hideCloser]="true"
  (action)="action($event)"
>
<div class="content">

  <div class="content_icon" [style.backgroundImage]="'url(/' + iconUrl + ')'"></div>
  <div class="content_text">
    {{ text }}
  </div>
</div>
</app-dialog>
